var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"b-slider"},[_c('div',{staticClass:"b-slider__value"},[_vm._v(_vm._s(_vm.hint))]),_vm._v(" "),_c('div',{staticClass:"b-slider__control no-ui-slider"}),_vm._v(" "),_c('div',{staticClass:"b-slider__label"},[_vm._v(_vm._s(_vm.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }